import { z } from "zod";

export const landingImageSchema = z.object({
  // Durable reference persisted as the row's `imageUrl` (S3 key or external URL).
  url: z.string().min(1),
  subtitle: z.string().optional().default(""),
  // Preview-only: presigned/display URL for the <img> src. Not persisted.
  displayUrl: z.string().optional(),
});

export const landingVideoSchema = z.object({
  // Durable reference persisted as the category's `videoUrl` (S3 key or URL).
  url: z.string().min(1),
  // Preview-only: presigned/display URL for the <video> src. Not persisted.
  displayUrl: z.string().optional(),
});

export const landingContentSchema = z.object({
  key: z.string().min(1, "Key is required"),
  title: z.string().min(1, "Title is required"),
  subtitle: z.string().optional(),
  paragraph: z.string().optional(),
  bullets: z.string().optional(),
  images: z.array(landingImageSchema).max(2, "Maximum 2 images").default([]),
  // Single hero video per category (matches the one `video_url` DB column).
  video: landingVideoSchema.nullable().default(null),
});

export type LandingImage = z.infer<typeof landingImageSchema>;
export type LandingVideo = z.infer<typeof landingVideoSchema>;
export type LandingContentFormData = z.infer<typeof landingContentSchema>;
